export default {"src":"/_next/static/media/CornealDisorders.a3120e7b.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};